<template>
    <v-footer
        padless
    >
        <v-row >
            <v-layout wrap>
                <v-flex xs12 md12 lg12 xl12
                    class="pa-1"
                >
                    <v-card
                        flat
                        tile
                        class="grey darken-1 white--text text-center"
                        xs12
                        >
                        <v-container>

                            <v-card-text>
                                <v-btn
                                v-for="(icon, index) in social"
                                :key="index"
                                class="mx-4 white--text"
                                icon
                                :href="icon.link"
                                target="_blank"
                                >
                                <v-icon size="24px">{{ icon.icon }}</v-icon>
                                </v-btn>
                            </v-card-text>

                            <v-card-text class="white--text pt-0">
                                <v-layout wrap>
                                    <v-flex xs12 md4 lg4 xl4
                                        class="pa-1"
                                    >
                                    <h4 class="red--text text--darken-4">Corte Superior de Justicia de Puno
                                        <v-btn icon target="_blank" href="https://www.google.com.pe/maps/place/15%C2%B050'27.2%22S+70%C2%B001'40.7%22W/@-15.8408907,-70.0285092,19z/data=!3m1!4b1!4m6!3m5!1s0x0:0x0!7e2!8m2!3d-15.8408921!4d-70.0279618">
                                            <v-icon color="red darken-4" x-large >
                                                mdi-map-marker
                                            </v-icon>
                                        </v-btn>
                                    </h4>
                                    <span>Sede Central - Jr. Puno 459, Plaza de Armas Puno - Perú.</span>
                                    
                                    <a href="tel:051599200" class="text-decoration-none white--text"><h5>Central Telefonica :</h5>
                                    <v-icon color="white" >mdi-phone</v-icon>
                                        (051) 599200
                                    </a>
                                    </v-flex>
                                    <v-flex xs12 md4 lg4 xl4
                                        class="pl-6"
                                    >
                                        <v-list dense color="transparent" dark>
                                            <v-subheader><h5>IMAGEN Y PRENSA</h5></v-subheader>
                                            <v-list-item link v-for="(item, index) in imagen" v-bind:key="index" :href="item.link" target="_blank">
                                                <v-list-item-icon>
                                                    <v-icon>{{item.icon}}</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    {{item.name}}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-flex>
                                    <v-flex xs12 md4 lg4 xl4
                                        class="pa-1"
                                    >
                                        <v-list dense color="transparent" dark>
                                            <v-subheader><h5>ENLACES DE INTERES</h5></v-subheader>
                                            <v-list-item link v-for="(item, index) in interes" v-bind:key="index" :href="item.link" target="_blank">
                                                <v-list-item-icon>
                                                    <v-icon>{{item.icon}}</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    {{item.name}}
                                                </v-list-item-content>
                                            </v-list-item>
                                            
                                        </v-list>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-text class="white--text">
                                {{ new Date().getFullYear() }} — <strong>Corte Superior de Justicia de Puno</strong>
                            </v-card-text>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-row>
    </v-footer>
</template>
<script>
export default {
    data: () => ({
        social: [
            { icon:'mdi-facebook',link:'https://www.facebook.com/CorteSuperiordeJusticiadePuno'},
            { icon:'mdi-youtube',link:'https://www.youtube.com/user/vozdejusticia/videos'},
            { icon:'mdi-twitter',link:'https://twitter.com/search?q=corte%20superior%20de%20justicia%20de%20puno&src=typed_query'},
        ],
        imagen: [
            {icon:'mdi-newspaper', name:'Noticias', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_inicio/as_imagen_prensa/as_noticias/'},
            {icon:'mdi-newspaper', name:'Actualidad / Importantes', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_inicio/as_imagen_prensa/as_de_actualidad_importancia/'},
            {icon:'mdi-notebook-multiple', name:'Publicaciones', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_inicio/as_imagen_prensa/publicaciones_csjpu/'},
            {icon:'mdi-youtube-subscription', name:'Galeria de videos', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_inicio/as_imagen_prensa/as_galeria_video/'},
            {icon:'mdi-music-box-multiple', name:'Galeria de audios', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_inicio/as_imagen_prensa/as_galeria_audio/'},
        ],
        interes: [
            {icon:'mdi-file-phone-outline', name:'Directorio telefónico', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_servicios/as_enlaces_de_interes/as_directorio_telefonico/'},
            {icon:'mdi-account-question-outline', name:'Orientación al litigante', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_servicios/as_enlaces_de_interes/as_orientacion_litigante/'},
            {icon:'mdi-account-child-outline', name:'Justicia para niños', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_servicios/as_enlaces_de_interes/as_justicia_para_ninos/'},
            {icon:'mdi-book-open-page-variant-outline', name:'Libro de Reclamaciones', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_servicios/as_enlaces_de_interes/as_libro_de_reclamaciones/'},
            {icon:'mdi-account-cash-outline', name:'REDAM', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_servicios/as_enlaces_de_interes/as_redam/'},
            {icon:'mdi-gavel', name:'Registro Nacional de Condenas', link:'https://www.pj.gob.pe/wps/wcm/connect/CorteSuperiorPunoPJ/s_csj_puno_nuevo/as_servicios/as_enlaces_de_interes/as_registro_nacional_condenas/'},

        ]
    }),
}
</script>